import axios from "axios";

// 创建axios实例
const instance = axios.create({
  timeout: request.timeout, // 请求超时时间
  headers: {
    "token": "1234567890123",
    "AppSource": "H5",
  }
});

// request拦截器
instance.interceptors.request.use(
  cfg => {
    return Promise.resolve(cfg);
  },
  error => {
    return Promise.reject(error);
  }
);

// response 拦截器
instance.interceptors.response.use(
  res => {
    return Promise.resolve(res.data);
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;